
import { defineComponent } from 'vue';

const Index = defineComponent({
  // setup() {},
});

export default Index;
